import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PocSelector from 'containers/request/Initial/Steps/Vendor/PocSelector';
import PocAdd from 'containers/request/Initial/Steps/Vendor/PocAdd';

class PointOfContact extends Component {
  constructor(props) {
    super(props);

    this.state = { isNewRequest: true, showSelector: true };
  }

  componentDidMount() {
    const isNewRequest = _.isUndefined(this.props.request.id);
    this.setState({ isNewRequest });
  }

  componentWillReceiveProps(nextProps) {
    const hasNoPocs = _.isEmpty(this.props.request.pocs);

    // update state only one time
    if (hasNoPocs && nextProps.request.pocs) {
      const pocListExists = !_.isEmpty(nextProps.request.pocs);
      this.setState({ showSelector: pocListExists });
    }
  }

  toggleSelector = value => {
    this.setState({ showSelector: value });
  };

  render() {
    if (!this.props.show) return null;

    const { showSelector, isNewRequest } = this.state;

    return (
      <div>
        <PocAdd
          show={!showSelector}
          isNew={isNewRequest}
          toggleSelector={this.toggleSelector}
        />
        <PocSelector
          show={showSelector}
          isNew={isNewRequest}
          toggleSelector={this.toggleSelector}
        />
      </div>
    );
  }
}

PointOfContact.propTypes = {
  show: PropTypes.bool,
  canSave: PropTypes.bool,
  canSubmit: PropTypes.bool
};

PointOfContact.defaultProps = {
  show: true,
  canSave: false,
  canSubmit: false
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(PointOfContact);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/PointOfContact.js